import styled from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, rydeColors } from "@ryde/theme";

export const BoundsBlockStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bounds-block",
})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  & .actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  & .description,
  & .hint {
    color: ${rydeColors.grey};
  }

  & .description {
    margin: 0;
    max-width: 72ch;
  }

  & .edges {
    display: grid;
    grid-template-columns: repeat(4, minmax(96px, 1fr));
    gap: 8px;
  }

  & .edges input {
    font-variant-numeric: tabular-nums;
    /* Trimmed from the default so a full coordinate fits the field at this width. */
    padding-inline: 8px;
  }
`;

/** The map itself: a short inline strip, since this sits inside a settings form rather than a drawer. */
export const BoundsBlockMapStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bounds-block-map",
})`
  height: 280px;
  width: 100%;
`;

/** A crop handle: the same white-circle-with-a-ring the polyline editor uses for its vertices. */
export const BoundsCornerHandleStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bounds-corner-handle",
})`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  box-sizing: border-box;
  background: ${rydeColors.white};
  border: 1px solid ${blueMui._700};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  cursor: move;
`;
